// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"da877cb3","341":"d04918e4","438":"5829b885","650":"9f40752a","706":"5ea01667","726":"7616b467"}[chunkId] + ".chunk.js";
};